<script lang="ts" setup>
import { OhVueIcon } from 'oh-vue-icons'
import { useAppLayout } from '@/stores/appLayout'
import { userData } from '@/Support/Users/userData'

const appLayout = useAppLayout()
const { openAiQuery } = appLayout
</script>

<template>
  <OhVueIcon
    v-if="userData.userPreferences.showAI"
    name="la-robot-solid"
    class="fixed z-10 size-12 rounded-full bg-primary-400 hover:bg-primary-500 dark:bg-primary-700 right-5 bottom-5 p-3 text-neutral-100 drop-shadow-2xl cursor-pointer"
    @click="openAiQuery"
  />
</template>
